import $ from 'jquery';
import common from '../base/common';
import emitter from '../base/emitter';
import scroller from '../components/scroller';

class Loader{

    constructor(){

        this.$loader = $('.Loader');
        this.$bar = $('.Loader__Bar');
        this.$images = $('img, .SectionSlider__ItemBg');
        this.imagesSrc = [];

        this.parseImages();

        this.endLoad = this.endLoad.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.loadPage = this.loadPage.bind(this);

        emitter.on('loader:show', this.showLoader);
        emitter.on('loader:load', this.loadPage);


    }

    parseImages(){

        let temp;

        this.$images.each((index, item) => {

            if($(item).is('img'))
                temp = $(item).attr('src');
            else{
                temp = $(item).css('background-image');
                temp = temp.replace('url(','').replace(')','').replace(/\"/gi, "");
            }

            this.imagesSrc.push(temp);

        })

        this.startLoad();

    }

    startLoad(){

        this.loadedImages = 0;
        for(var index in this.imagesSrc){

            let tempImg = new Image();
            $(tempImg).on('load', () => {

                this.loadedImages ++;
                this.updateLoadStatus();

                if(this.loadedImages == this.imagesSrc.length){
                    setTimeout(this.endLoad, 300);
                }

            }).attr('src', this.imagesSrc[index]);

        }

    }

    updateLoadStatus(){

        TweenMax.to(this.$bar, 0.3, { height: common.screen.height * (this.loadedImages / this.imagesSrc.length)})

    }

    endLoad(){

        TweenMax.to(this.$loader, 1, {x: common.screen.width * -1, ease: Power3.easeInOut, onComplete: () => {

            this.reset();
            emitter.emit('page:load');

        } });

    }

    reset(){

        this.$loader.hide();
        TweenMax.set(this.$loader, {x: 0, opacity: 0});
        TweenMax.set(this.$bar, { height: 0 })

    }

    showLoader(){

        let d = $.Deferred();

        scroller.disable(true);
        this.$loader.show();
        TweenMax.to(this.$loader, 0.3, { opacity: 1, onComplete: () => {

            d.resolve();

        }});

        return d.promise();

    }

    loadPage(html){

        // let d = $.Deferred();

        this.endLoad();

        // d = this.showLoader();
        // d.done(() => {
        //
        //     console.log('loader visualizzato');
        //     console.log('Data: ', html);
        //     TweenMax.set(window , { scrollTo: { y: 0, autoKill:false }, })
        //     TweenMax.set($('#SectionSlider .SectionSlider__Item.__active .SectionSlider__ItemBg'), { x: '-50%', y: '-50%'});
        //
        // })


    }


}

export default new Loader();


// WEBPACK FOOTER //
// ./js/layouts/loader.js